import React, { useEffect, useState } from 'react';
import { StepWizardChildProps } from 'react-step-wizard';

import { WfInfoResponse } from 'models/response';

import utils from 'utils';

import { Top, StepContainer, StyledRowWrapper, StyledLine } from './styles';

import Header from 'components/Modal/Header';
import Dropdown from 'components/Input/dropdown/Dropdown';
import CommonButton from 'components/Buttons/CommonButton';
import Textarea from 'components/Input/Textarea';
import TextInput from 'components/Input/TextInput';
import NotesInserter, { Note } from 'components/NoteInserter/NoteInserter';
import services from 'services';
import selectors from 'state/selectors';
import { useSelector } from 'react-redux';

export interface Props extends StepWizardChildProps {
  note: string;
  setNote: (text: string) => void;

  infoForSuspend: WfInfoResponse;
  dropOptOne: { value: string; label: string }[];
  selectedReason: { value: string; label: string };
  selectedDescription: { value: number; label: string } | null;
  infoInput: string;
}

const NoteComp: React.FC<Partial<Props>> = (props) => {
  const { note, setNote, infoForSuspend, dropOptOne, selectedReason, selectedDescription, infoInput } = props;
  const t = utils.intl.useTranslator();
  const idCompany = useSelector(selectors.documents.selectAllActiveDocuments)[0]?.idCompany || -1;
  const companyName = useSelector(selectors.documents.selectAllActiveDocuments)[0]?.companyName || undefined;
  const [noteList, setNoteList] = useState<Note[]>([]);

  useEffect(() => {
    setNoteList(
      infoForSuspend === undefined || selectedDescription?.label === undefined
        ? []
        : infoForSuspend.causalNotes[selectedDescription?.label]?.map((note) => ({
            id: note.idNote,
            text: note.note,
          })),
    );
  }, [infoForSuspend, selectedDescription]);

  const onUseNote = (value: string) => {
    setNote && setNote(value);
  };
  const onAddNote = async (value: string) => {
    try {
      const { data } = await services.addNote(idCompany, selectedDescription?.label || '', value);
      if (data) {
        setNoteList((prev) => [
          ...prev,
          {
            id: data,
            text: value,
          },
        ]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const onDeleteNote = async (id: string | number) => {
    try {
      const res = await services.deleteNote(Number(id));
      if (res) {
        setNoteList((prev) => prev.filter((note) => note.id !== id));
      }
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <StepContainer>
      <Header title={t('note')} />
      {dropOptOne ? (
        <Top>
          <CommonButton
            id="back-btn"
            value={t('back')}
            scope="tertiary"
            action={() =>
              selectedReason?.value === 'causale'
                ? props.previousStep
                  ? props.previousStep()
                  : {}
                : props.goToStep
                ? props.goToStep(2)
                : {}
            }
          />
          <StyledRowWrapper>
            <Dropdown id="reason-dropdown" value={selectedReason} disabled options={dropOptOne} />
            {selectedReason?.value === 'causale' ? (
              infoForSuspend ? (
                <Dropdown
                  id="description-dropdown"
                  options={utils.input.buildOptions(infoForSuspend.causals || [], 'causalName', 'idWfCausal')}
                  value={selectedDescription}
                  disabled
                />
              ) : null
            ) : (
              <TextInput id="info-input" disabled value={infoInput} />
            )}
          </StyledRowWrapper>
        </Top>
      ) : null}
      <StyledLine />
      <div style={{ marginBottom: '12px' }}>
        <NotesInserter
          notes={noteList}
          onDeleteNote={onDeleteNote}
          onAddNote={onAddNote}
          onUseNote={onUseNote}
          companyName={companyName}
        ></NotesInserter>
      </div>
      <Textarea onChange={(e) => setNote && setNote(e.target.value)} value={note} />
    </StepContainer>
  );
};

export default NoteComp;
